import React, { Component } from 'react';
import styles from './styles.sass';

class DropdownButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
  }

  handleClick = e => {
    this.setState({ isActive: !this.state.isActive });
    if (this.props.onClick) {
      this.props.onClick();
    }
  };

  handleHover = e => {
    this.setState({ isActive: true });
  };

  handleBlur = e => {
    this.setState({ isActive: false });
  };

  handleContentClick = e => {
    // prevent clicks on content from blurring button
    e.preventDefault();
    e.stopPropagation();
  };

  render() {
    const {
      activeOnHover,
      direction = 'bottom',
      dropdownComponent,
      className,
      children,
      preventBlur,
      ariaLabel,
    } = this.props;
    const { isActive } = this.state;
    return (
      <div className={styles.dropdownButton}>
        <button
          aria-label={ariaLabel}
          type="button"
          {...(activeOnHover
            ? {
                onMouseOver: this.handleHover,
                onMouseOut: this.handleBlur,
              }
            : {
                onClick: this.handleClick,
              })}
          className={className}
          onBlur={!preventBlur ? this.handleBlur : null}
        >
          {children}
        </button>
        {isActive ? (
          <div
            className={`${styles.dropdown} ${styles[direction]} `}
            onMouseDown={this.handleContentClick}
          >
            {React.cloneElement(dropdownComponent, {
              onClose: this.handleBlur,
            })}
          </div>
        ) : null}
      </div>
    );
  }
}

export default DropdownButton;
